// Email validation - RFC 5322 simplified
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const validateEmail = (email) => {
  if (!email || email.trim() === '') {
    return 'Email is required'
  }
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address'
  }
  return null
}

export const validateName = (name) => {
  if (!name || name.trim() === '') {
    return 'Name is required'
  }
  if (name.trim().length < 2) {
    return 'Name must be at least 2 characters'
  }
  return null
}

export const validatePhone = (phone) => {
  if (!phone || phone.trim() === '') {
    return null // Optional field
  }

  const phoneRegex = /^[\d\s\-\+\(\)]*$/
  if (!phoneRegex.test(phone)) {
    return 'Please enter a valid phone number'
  }

  const digitsOnly = phone.replace(/\D/g, '')
  if (digitsOnly.length < 10 || digitsOnly.length > 15) {
    return 'Phone number must contain 10-15 digits'
  }
  return null
}

export const validateFormData = (formData) => {
  return {
    name: validateName(formData.name),
    email: validateEmail(formData.email),
    phone: validatePhone(formData.phone)
  }
}


